
import { defineComponent, ref, inject } from "vue";
import axios from "@/api/axios";
import { useRoute } from "vue-router";
import { timeFormat } from "@/utils/dateFormat";
import PublishComment from "@/components/common/PublishComment.vue";
import qs from "qs";
import Toast from "@/components/UI/Toast";
import Loading from "@/components/UI/Loading";
export default defineComponent({
  name: "CourseCommentDetail",
  components: {
    PublishComment,
    Loading
  },
  setup(props, ctx) {

    const route = useRoute();
    const id = route.query.id;
    const entity = ref<any>(null);
    const erjiPostList = ref<object>([]);
    const loadOption = {
      text: "加载中...",
      color: "#df0024",
      textColor: "#df0024",
    };
    axios.get("/M/Discover/CourseCommentDetail/" + id).then(res => {
        const data = res.data.obj;
        entity.value = data.entity;
        erjiPostList.value = data.erjiPostList;
    })

    function dateFormat(datetime: string) {
        return datetime.substr(0,16)
    }

    const comment = ref("");
    const my = inject("userInfo") as object;
    function subComment() {
      if (!comment.value) {
        Toast({
          type: "warning",
          title: "请先输入评论再提交哦~",
        });
        return false;
      }
      const data = qs.stringify({
        id,
        content: "回复"+ entity.value.user.nickName + "：" + comment.value,
      });
      axios
        .post("/M/CourseServer/DoPostCourseCommentPost", data)
        .then((res) => {
          if (res.data.success) {
            Toast({
              type: "success",
              title: res.data.msg,
            });
            (erjiPostList.value as object[]).unshift({
              ...res.data.obj,
              isAlreadyZan: 0,
              user: {
                ...my,
                userImg: (my as any).userImg,
              },
            });
            comment.value = "";
          } else {
            Toast({
              type: "error",
              title: res.data.msg,
            });
          }
        })
        .catch((err) => {
          const message = err.message ? err.message : "未知错误，请联系管理员";
          Toast({
            type: "error",
            title: message,
          });
        });
    }
    return {
      entity,
      erjiPostList,
      dateFormat,
      timeFormat,
      subComment,
      comment,
      loadOption
    };
  },
});
